import { TopRelationshipsReducers } from './containers/TopRelationships';
import { TopRelationshipsToMyExecutivesReducers } from './containers/TopRelationshipsToMyExecutives';

export default from './RelationshipsMapping';
export const RelationshipsMappingReducers = {
  ...TopRelationshipsReducers,
  ...TopRelationshipsToMyExecutivesReducers,
};
